import slice from '../reducer/slice';

import { BBox } from "@turf/helpers";

const operation = (fitBounds: BBox) => slice.actions.setStationsFitBounds(fitBounds);

export default operation;
